import React, { useEffect } from 'react';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';
import AdminFooter from './AdminFooter';
import { ADMIN_BRAND } from '../../utils/brandAssets';
import { usePageBrand } from '../../hooks/usePageBrand';
import '../css/AdminBrand.css';

const adminCSS = [
  '/admin-assets/vendors/mdi/css/materialdesignicons.min.css',
  '/admin-assets/vendors/flag-icon-css/css/flag-icons.min.css',
  '/admin-assets/vendors/css/vendor.bundle.base.css',
  '/admin-assets/vendors/font-awesome/css/font-awesome.min.css',
  '/admin-assets/css/vertical-light-layout/style.css',
];

const adminJS = [
  '/admin-assets/vendors/js/vendor.bundle.base.js',
  '/admin-assets/vendors/chart.js/chart.umd.js',
  '/admin-assets/vendors/jquery-circle-progress/js/circle-progress.min.js',
  '/admin-assets/js/jquery.cookie.js',
  '/admin-assets/js/off-canvas.js',
  '/admin-assets/js/hoverable-collapse.js',
  '/admin-assets/js/misc.js',
  '/admin-assets/js/settings.js',
  '/admin-assets/js/todolist.js',
];

function loadScriptsSequentially(scripts, index = 0) {
  if (index >= scripts.length) return;
  const existing = document.querySelector(`script[src="${scripts[index]}"]`);
  if (existing) {
    loadScriptsSequentially(scripts, index + 1);
    return;
  }
  const script = document.createElement('script');
  script.src = scripts[index];
  script.setAttribute('data-admin', 'true');
  script.onload = () => loadScriptsSequentially(scripts, index + 1);
  document.body.appendChild(script);
}

const AdminLayout = ({ children }) => {
  usePageBrand({ title: ADMIN_BRAND.title, favicon: ADMIN_BRAND.favicon });

  useEffect(() => {
    // Inject CSS
    adminCSS.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.setAttribute('data-admin', 'true');
        document.head.appendChild(link);
      }
    });

    // Load JS sequentially so jQuery is ready before dependent scripts
    loadScriptsSequentially(adminJS);

    // Do NOT remove CSS/JS on unmount — removing causes layout flash on navigation
  }, []);

  return (
    <div className="container-scroller">
      <AdminHeader />
      <div className="container-fluid page-body-wrapper">
        <AdminSidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            {children}
          </div>
          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
